import { globalStore } from '../../../../../modules/shared/shared.global-service';
import { selectFolder } from '../../../../../modules/content/store/person/person.selectors';
import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { SuklAdministrationRouteObject } from '@libs/types/src/list/object-type/sukl-administration-route.object';
import { InfiniteScrollStore } from '../../../../../modules/shared/store/common/infinite-scroll.store';
import { SuklPharmaceuticalFormObject } from '@libs/types/src/list/object-type/sukl-pharmaceutical-form.object';
import {
    folderEPrescriptionAnamnesisFrag, suklAdministrationRouteSelectFrag, suklPharmaceuticalFormSelectFrag,
} from './folder-e-prescription-form.query';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';

@Injectable()
export class FolderEPrescriptionFormStore extends ComponentStoreV2Factory {
    public folder = globalStore!.selectSignal(selectFolder);
    public readonly suklAdministrationRouteScroll = new InfiniteScrollStore<SuklAdministrationRouteObject>(
        this.api.getListSuklAdministrationRoutes,
        {},
        false,
        suklAdministrationRouteSelectFrag,
    );
    public readonly suklPharmaceuticalFormScroll = new InfiniteScrollStore<SuklPharmaceuticalFormObject>(
        this.api.getListSuklPharmaceuticalForms,
        {},
        false,
        suklPharmaceuticalFormSelectFrag,
    );
    public readonly suklCannabisPharmaceuticalFormScroll = new InfiniteScrollStore<SuklPharmaceuticalFormObject>(
        this.api.getListSuklPharmaceuticalForms,
        FilterBuilder.filter({ cannabis: true }),
        false,
        suklPharmaceuticalFormSelectFrag,
    );
    public readonly anamnesis = computed(() => this.data.getAnamneses()?.items?.[0] ?? null);

    public loadAnamnesis(folderId: number): void {
        const filter = new FilterBuilder({ folderId }).sort('updatedAt', 'DESC').limit(1).filter();
        this.api.getAnamneses(filter, folderEPrescriptionAnamnesisFrag).then();
    }
}
